import { observer } from 'mobx-react-lite';

import { Alert } from '@components/alert';
import { Button } from '@components/button';
import { CopyText } from '@components/copy-text-field';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { SocialShareButtons } from 'components/ShareJob/SocialShareButtons';
import { Tab, TabList, useTabState } from 'components/Tabs';
import { useAuthenticatedUser } from 'features/authentication';
import { Modal } from 'features/modals';
import { sharingSiteUrl } from 'features/routing';
import { useStore } from 'models/Provider';

export const ShareModal = observer(({ closeModal }) => {
  const { t } = useStore();
  const tabState = useTabState();
  const referral = tabState.selectedId === '1';
  const me = useAuthenticatedUser();
  const url = sharingSiteUrl(me, referral);

  return (
    <Modal>
      <Modal.Header text={t('sharejob.careersite.title')} />
      <div>
        <TabList state={tabState} label="Direct or Referral selection">
          <Tab>{t('sharejob.selected.tab.direct')}</Tab>
          <Tab>{t('sharejob.selected.tab.referral')}</Tab>
        </TabList>
        <Separator />
      </div>
      {referral && <Alert variant="info">{t('sharejob.label')}</Alert>}
      <Stack space={1}>
        <CopyText
          copyText={t('copy.button.text')}
          copiedText={t('copy.button.copied')}
          label={t('sharejob.copy.header.' + (referral ? 'referral' : 'direct'))}
          value={url}
        />
      </Stack>

      <Separator />
      <Text font="heading2" color="purple100" text={t('sharejob.header.sharing.title')} />
      <SocialShareButtons url={url} />
      <Modal.Actions>
        <Button variant="secondary" onClick={closeModal} text={t('sharejob.modal.close')} />
      </Modal.Actions>
    </Modal>
  );
});
